var map = {
	"./1000000Pkg.png": "WeXj",
	"./100000Pkg.png": "+lJ1",
	"./500000Pkg.png": "X3PX",
	"./50000Pkg.png": "crFb",
	"./5P_dot.png": "kxsM",
	"./5P_dotted.png": "WQ2z",
	"./Booking.png": "jXBf",
	"./BookingHover.png": "aF3Q",
	"./bookProgress.png": "twgb",
	"./box4arrow.png": "+Oss",
	"./box4bg.png": "pWuC",
	"./gzhCode.jpg": "LMaB",
	"./jianshi.png": "WxBD",
	"./jianshiClick.png": "rV4b",
	"./jianshiIcon.png": "i8Jq",
	"./jianshiSkill.png": "R5Do",
	"./jianshiTitle.png": "SVky",
	"./new_bg.png": "MJIp",
	"./news0.png": "+qOJ",
	"./news1.png": "51NG",
	"./progress_dot.png": "z19f",
	"./progress_dotted.png": "FJSB",
	"./rightSides.png": "bskj",
	"./shushi.png": "QK8k",
	"./shushiClick.png": "Ela+",
	"./shushiIcon.png": "5zX4",
	"./shushiSkill.png": "0mIq",
	"./shushiTitle.png": "abZo",
	"./yingren.png": "CJOl",
	"./yingrenClick.png": "JW/H",
	"./yingrenIcon.png": "scLq",
	"./yingrenSkill.png": "r1WL",
	"./yingrenTitle.png": "r4cR",
	"./youxia.png": "jJWb",
	"./youxiaClick.png": "2plq",
	"./youxiaIcon.png": "46gj",
	"./youxiaSkill.png": "3OSM",
	"./youxiaTitle.png": "W1Yy",
	"./ys_bg.jpg": "zYcj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0tcK";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image ^\.\/.*$
// module id = 0tcK
// module chunks = 0